/**
         * 只可输入数字自定义指令
         */
export default {
    bind: (el) => {
        let state = 0 // 是否为中文输入法输入
        let formatVal = /^[0-9]$/
        el.handler = function (inputVal) {
            if (state) {
                return
            }
            let data = inputVal.data
            if (!formatVal.test(data)) {
                if (!data) {
                    return
                }
                return (el.children[0].value = el.children[0].value.replace(data, ''))
            }
        }
        // 中文输入法键入开始
        el.onCompositionStart = () => {
            state = 1
            el.children[0].value = el.children[0].value
        }
        // 中文输入法键入结束
        el.onCompositionEnd = (e) => {
            if (formatVal.test(e.data)) {
                return
            }
            state = 0
            el.children[0].value = el.children[0].value.replace(e.data, '')
            return false
        }
        el.addEventListener('input', el.handler)
        el.addEventListener('compositionstart', el.onCompositionStart)
        el.addEventListener('compositionend', el.onCompositionEnd)
    },
    unbind: (el) => {
        el.removeEventListener('input', el.handler)
        el.removeEventListener('compositionstart', el.onCompositionStart)
        el.removeEventListener('compositionend', el.onCompositionEnd)
    }
}